import { render, staticRenderFns } from "./PartialPriceListCustomer.vue?vue&type=template&id=d8b99b46&"
import script from "./PartialPriceListCustomer.vue?vue&type=script&lang=js&"
export * from "./PartialPriceListCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PartialPriceListCustomer.vue?vue&type=style&index=0&id=d8b99b46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports